<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加驾驶员信息"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="vehicleDriverInfo" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="vehicleDriverInfo.name" placeholder="请输入驾驶员名称">
        </Input>
      </FormItem>
      <FormItem prop="idCardNum">
        <Input v-model="vehicleDriverInfo.idCardNum" placeholder="请输入身份证号码">
        </Input>
      </FormItem>
      <FormItem prop="driverCardNum">
        <Input v-model="vehicleDriverInfo.driverCardNum" placeholder="请输入司机卡号">
        </Input>
      </FormItem>
      <FormItem prop="phoneNum">
        <Input v-model="vehicleDriverInfo.phoneNum" placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <Input v-model="vehicleDriverInfo.address" placeholder="请输入联系地址">
        </Input>
      </FormItem>
      <FormItem prop="remark">
        <Input type="textarea" v-model="vehicleDriverInfo.remark" placeholder="备注">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'AddVehicleDriverInfoModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '驾驶员名称不能为空', trigger: 'blur' }
          ]
        }
      },
      idCardNumRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '身份证号码不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        vehicleDriverInfo: {
          name:null,
          idCardNum:null,
          driverCardNum:null,
          phoneNum:null,
          address:null,
          remark:null
        }
      }
    },
    methods: {
      ...mapActions([
        'VehicleDriverInfoServ_AddObj'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '添加驾驶员信息',
          content: '<p>是否确认添加驾驶员信息</p>',
          onOk: () => {
            store.dispatch('VehicleDriverInfoServ_AddObj', {params: this.vehicleDriverInfo}).then(() => {
              this.$Message.success('添加驾驶员信息成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.vehicleDriverInfo.name = null
          this.vehicleDriverInfo.phoneNum = null
          this.vehicleDriverInfo.address = null
          this.vehicleDriverInfo.remark = null
          this.vehicleDriverInfo.idCardNum = null
          this.vehicleDriverInfo.driverCardNum = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          idCardNum: this.idCardNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
